const devices = [
  {
    path: '/devices',
    name: 'devices.index',
    component: () => import('@/views/devices/DeviceList.vue'),
    meta: {
      pageTitle: 'Dispositivos',
      breadcrumb: [
        {
          text: 'Disponíveis',
          active: true,
        },
      ],
    },
  },
]

export default devices
